(function () {
  function initialize(root) {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    var form = root.querySelector('form'), button = root.querySelector('.wf-submit'), error = root.querySelector('.wf-error');
    button.disabled = false;
    var website = form.elements['contact[website]'];
    website.addEventListener('blur', function () { var value = website.value.trim(); if (value && !/^[a-z][a-z0-9+.-]*:\/\//i.test(value)) value = 'https://' + value; website.value = value; });
    form.addEventListener('submit', async function (event) {
      event.preventDefault();
      if (button.disabled) return;
      error.hidden = true;
      website.dispatchEvent(new Event('blur'));
      if (!form.reportValidity()) return;
      button.disabled = true; button.textContent = 'Saving your application…';
      var controller = new AbortController(), timeout = setTimeout(function () { controller.abort(); }, 25000);
      try {
        var response = await fetch(form.action, {method:'POST',body:new FormData(form),headers:{Accept:'application/json'},credentials:'same-origin',redirect:'error',signal:controller.signal});
        if (!response.headers.get('content-type')?.includes('application/json')) throw new Error('We couldn’t confirm your application. Your details are still here. Please try again or email info@theforestrystudio.com.');
        var data = await response.json();
        if (!response.ok || data.ok !== true || !/^WF-\d+$/.test(data.receipt || '')) {
          var messages = data.errors ? Object.values(data.errors).flat() : [];
          throw new Error(messages.length ? messages.join(' ') : 'We couldn’t confirm your application. Please try again or email info@theforestrystudio.com.');
        }
        form.hidden = true; root.querySelector('.wf-card-heading').hidden = true;
        var success = root.querySelector('.wf-success'); success.hidden = false;
        success.querySelector('.wf-receipt').textContent = 'Your reference: ' + data.receipt;
        success.focus(); success.scrollIntoView({behavior:'smooth',block:'center'});
      } catch (failure) {
        error.textContent = failure.name === 'AbortError' ? 'This is taking longer than expected. Your details are still here. Please retry; we’ll keep one application for your email.' : (failure instanceof TypeError ? 'We couldn’t reach the application service. Your details are still here. Please try again or email info@theforestrystudio.com.' : failure.message);
        error.hidden = false; error.focus(); button.disabled = false; button.innerHTML = 'Send application <span aria-hidden="true">↗</span>';
      } finally { clearTimeout(timeout); }
    });
  }
  document.querySelectorAll('.wf-application').forEach(initialize);
  document.addEventListener('shopify:section:load', function (event) { event.target.querySelectorAll('.wf-application').forEach(initialize); });
})();
